import setGrabCursor from './setGrabCursor.js';
import unsetGrabCursor from './unsetGrabCursor.js';
export default {
  setGrabCursor,
  unsetGrabCursor
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/core/grab-cursor/index.js
// module id = 2829
// module chunks = 30 31 33